/**
 * Case studies listing — reveal + light parallax (no GSAP).
 * Respects prefers-reduced-motion.
 */
(() => {
  const ROOT_SELECTOR = '[data-blog-listing], [data-blog-case-study-listing], [data-chosen-article]';
  const ITEM_SELECTOR = '[data-blog-case-study]';
  const MEDIA_SELECTOR = '[data-blog-case-study-media]';
  const PARALLAX_RANGE = 20;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  class BlogListing {
    constructor(root) {
      this.root = root;
      this.items = Array.from(root.querySelectorAll(ITEM_SELECTOR));
      this.ticking = false;

      if (this.items.length === 0) return;

      if (reducedMotion.matches || !('IntersectionObserver' in window)) {
        this.items.forEach((item) => item.classList.add('is-revealed'));
        return;
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-revealed');
            this.observer.unobserve(entry.target);
          });
        },
        {
          root: null,
          rootMargin: '0px 0px -8% 0px',
          threshold: 0.12,
        }
      );

      this.items.forEach((item) => this.observer.observe(item));

      this.onScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.updateParallax();
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      window.requestAnimationFrame(() => {
        this.ticking = false;
        this.updateParallax();
      });
    }

    updateParallax() {
      if (reducedMotion.matches) return;

      const viewportMid = window.innerHeight * 0.5;

      this.items.forEach((item) => {
        if (!item.classList.contains('is-revealed')) return;

        const media = item.querySelector(MEDIA_SELECTOR);
        const image = media?.querySelector('.blog-case-study__image');
        if (!media || !image) return;

        const rect = media.getBoundingClientRect();
        const progress = (viewportMid - (rect.top + rect.height * 0.5)) / window.innerHeight;
        const offset = Math.max(-PARALLAX_RANGE, Math.min(PARALLAX_RANGE, progress * PARALLAX_RANGE));
        image.style.transform = `translate3d(0, ${offset.toFixed(2)}px, 0)`;
      });
    }
  }

  function init(scope) {
    (scope || document).querySelectorAll(ROOT_SELECTOR).forEach((root) => {
      if (root.blogListing) return;
      root.blogListing = new BlogListing(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });
})();
